import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setClientCSS, getClientprofile } from "../../slices/vehicleSlice";

const ClientTheme = ({ children }) => {
    const [isThemeLoaded, setIsThemeLoaded] = React.useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        const pathnameParts = window.location.pathname.split('/');
        const client = pathnameParts[1] !== 'cars' ? pathnameParts[1] : 'jdpa';
        const country = pathnameParts[2] !== 'ca' ? 'us' : pathnameParts[2];

        // Making an API call just to Fetch client theme before rendering any Components
        dispatch(getClientprofile({ client, country }))
            .then((response) => {
                const themeFromAPI = response.payload.theme;
                const { supportedLanguages } = response.payload;

                sessionStorage.setItem("supportedLanguages", supportedLanguages);

                if (themeFromAPI) {
                    dispatch(setClientCSS(themeFromAPI));

                    const link = document.createElement('link');
                    link.href = themeFromAPI;
                    link.rel = 'stylesheet';

                    link.onload = () => {
                        setIsThemeLoaded(true);
                    };

                    link.onerror = () => {
                        setIsThemeLoaded(true);
                    };

                    document.head.appendChild(link);
                } else {
                    setIsThemeLoaded(true);
                }
            })
            .catch((error) => {
                console.error('Failed to fetch client info:', error);
                setIsThemeLoaded(true);
            });
    }, [dispatch]);

    if (!isThemeLoaded) {
        return (
            <link
                href="/src/defaultCss.css"
                rel="stylesheet"
            />
        );
    }
    return children;
};

export default ClientTheme;